import React from 'react';
import CarScheme from '../schemes/car.svg';
import VanScheme from '../schemes/van.svg';
import ContainerScheme from '../schemes/container.svg';
import HookliftScheme from '../schemes/hooklift.svg';

class Scheme extends React.Component {

  render() {
    let SchemeEl = CarScheme;
    switch (this.props.scheme) {
      case 'van':
        SchemeEl = VanScheme;
        break;
      case 'container':
        SchemeEl = ContainerScheme;
        break;
      case 'hooklift':
        SchemeEl = HookliftScheme;
        break;
    }
    return <div>
      <SchemeEl onClick={e => {
        let node = e.target;
        while (node.id !== 'CarScheme' && !node.classList.contains('js_clickable')) {
          node = node.parentNode;
        }
        const posX = this.props.position.x / this.props.elementDimensions.width;
        const posY = this.props.position.y / this.props.elementDimensions.height;
        this.props.clicked(posX, posY, this.props.elementDimensions.width, this.props.elementDimensions.height, node.id);
      }
      } />
    </div>;
  }
}

export default Scheme;
